import BaseObject from "./BaseObject";
import BaseModelReference from "./BaseModelReference";
import Consumer from "./Consumer";
import Fuse from "./Fuse";

import BaseModelReferenceTreeviewModel from "../modelTreeViews/BaseModelReferenceTreeviewModel";

export default class FuseConsumerReference extends BaseModelReference {
  public get className(): string {
    return "FuseConsumerReference"; // no itx
  }

  fuse: Fuse;

  // getName(): string {
  //   const consumer = this.referencedObject as Consumer;
  //   const channel = consumer.getConnectedChannel();

  //   let res = "";
  //   if (consumer) {
  //     res = `${consumer.name} `;
  //   }
  //   if (channel) {
  //     res = `${channel.name} -> ` + res;
  //   }

  //   return res;
  // }
  // setName(newValue: string) {}

  delete(): Array<BaseObject> {
    super.delete();

    const consumer = this.referencedObject as Consumer;
    if (consumer) {
      consumer.fuse = undefined;
    }
    consumer.raiseOnChange("fuse");
    this.fuse.raiseOnChange("childCollection");

    return [];
  }

  undelete() {
    //
    // MWE 8.9.2026
    // das muss man hier nochmals genau analysieren
    // wir lassen es erstmal wie es frühre war auch mit dem neuen undo
    //
    super.undelete();
    const consumer = this.referencedObject as Consumer;
    if (consumer) {
      consumer.fuse = undefined;
      consumer.raiseOnChange("fuse");
      this.fuse.raiseOnChange("childCollection");
    }
  }

  constructor(fuse: Fuse, consumer: Consumer) {
    super({ referencedObject: consumer }, fuse);
    this.fuse = fuse;
    this.treeViewModel = new BaseModelReferenceTreeviewModel(this);
  }
}
